import MuiFormHelperText from '@mui/material/FormHelperText';
import * as React from 'react';
import { IFormHelperTextProps } from './form-helper-text-props';

export function FormHelperText({ children, sx }: IFormHelperTextProps) {
  return (
    <MuiFormHelperText className="form-helper-text-scope form-helper-text" sx={sx}>
      {children}
    </MuiFormHelperText>
  );
}
